import { Navigate, Route, Routes } from 'react-router-dom'

import { AppShell } from '@/components/AppShell'
import { Spinner } from '@/components/ui/misc'
import { AuditPage } from '@/features/audit/AuditPage'
import { AuthProvider, useAuth } from '@/features/auth/AuthProvider'
import { LoginPage } from '@/features/auth/LoginPage'
import { BrowserPage } from '@/features/browser/BrowserPage'
import { ApiKeysPage } from '@/features/keys/ApiKeysPage'
import { SharePage } from '@/features/shares/SharePage'
import { SharesPage } from '@/features/shares/SharesPage'
import { ConflictDialog } from '@/features/upload/ConflictDialog'
import { UploadProvider } from '@/features/upload/UploadProvider'
import { UploadQueue } from '@/features/upload/UploadQueue'

function AuthenticatedApp() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner className="h-6 w-6" />
      </div>
    )
  }

  if (!user) return <LoginPage />

  return (
    // The upload provider sits inside the authenticated tree so an in-flight
    // queue is discarded on sign-out rather than surviving into another
    // session.
    <UploadProvider>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/browse" element={<BrowserPage />} />
          <Route path="/shares" element={<SharesPage />} />
          <Route path="/keys" element={<ApiKeysPage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="*" element={<Navigate to="/browse" replace />} />
        </Route>
      </Routes>

      <ConflictDialog />
      <UploadQueue />
    </UploadProvider>
  )
}

export function App() {
  return (
    <Routes>
      {/*
        Share links resolve outside the AuthProvider entirely. A recipient has
        no account, so this page must never trigger a session lookup, never
        redirect to the login form, and never expose any navigation into the
        rest of the application.
      */}
      <Route path="/share/:token" element={<SharePage />} />
      <Route
        path="*"
        element={
          <AuthProvider>
            <AuthenticatedApp />
          </AuthProvider>
        }
      />
    </Routes>
  )
}
